type Receipt = {
  label: string;
  value: string;
  href?: string;
};

const receipts: Receipt[] = [
  { label: 'Gründung', value: 'HPI-Spinoff · Berlin · seit 2015' },
  { label: 'Software-Pedigree', value: 'Luca · N2O · SEAMLESSme' },
  { label: 'Forschungs-Förderung', value: 'BMWK · BMBF (SENSIBLE-KI)' },
  {
    label: 'Weiteres Portfolio',
    value: 'nexenio.com →',
    href: 'https://www.nexenio.com',
  },
];

export default function Credibility() {
  return (
    <section aria-label="Trägerkontext" className="border-b border-rule bg-bg-elev/30">
      <div className="mx-auto max-w-[1280px] px-6 py-8 md:px-10 md:py-10">
        <ul className="grid gap-x-10 gap-y-6 sm:grid-cols-2 lg:grid-cols-4">
          {receipts.map((r) => (
            <li key={r.label}>
              <p className="font-mono text-[11px] uppercase tracking-[0.14em] text-fg-muted">
                {r.label}
              </p>
              {r.href ? (
                <a
                  href={r.href}
                  className="mt-2 block text-sm font-medium text-ink hover:text-accent"
                >
                  {r.value}
                </a>
              ) : (
                <p className="mt-2 text-sm font-medium text-ink">{r.value}</p>
              )}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
